// 역할: SDK 카테고리 헤더 아이콘 표시
import { getCategoryById, ICON_MAP } from '../../../config/menu.config';
import { useRegion } from '../../hooks/useRegion';

interface SDKCategoryIconProps {
  sdkType: string;
}

export const CategoryIcon = ({ sdkType }: SDKCategoryIconProps) => {
  const { isOverseas } = useRegion();

  const getIconPath = (type: string) => {
    // 해외향 모드에서 Hcell SDK는 Spreadsheet 아이콘 사용
    if (isOverseas && type === 'hcell') {
      return '/assets/SDK_Spreadsheet.png';
    }

    // 설정에서 카테고리 정보를 가져와서 아이콘 타입 확인
    const categoryConfig = getCategoryById(type);
    const iconType = categoryConfig?.iconType ?? type;

    // 설정 기반 아이콘 매핑
    return ICON_MAP[iconType] ?? ICON_MAP.hcell;
  };

  return <img src={getIconPath(sdkType)} alt={`${sdkType} icon`} className='w-10 h-10 object-contain' />;
};

export default CategoryIcon;
